export default __webpack_public_path__ + "static/media/grp1_w640.5640e88a.jpeg";